import styled from "styled-components";

export const UnableToCheckoutContainer = styled.div`
  color: white;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
